import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {Title} from '../../../../components/title/title';
import {TranslatePipe} from '@ngx-translate/core';
import {TabItem, TabMenu} from '../../../../components/tab-menu/tab-menu';
import {RouterOutlet} from '@angular/router';
import {RouteUri} from '../../../../constants/route-uri';
import {CurrentUserService} from '../../../../services/current-user.service';

@Component({
  selector: 'elcia-settings-summary',
  imports: [
    Title,
    TranslatePipe,
    TabMenu,
    RouterOutlet
  ],
  templateUrl: './settings-summary.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsSummary {
  private readonly currentUserService = inject(CurrentUserService);

  protected readonly items = computed<TabItem[]>(() => {
    const items: TabItem[] = [
      // Todo settings are only reachable by users allowed to access todos.
      ...(this.currentUserService.hasTodoAccess() ? [{
        icon: 'todo' as const,
        label: 'entity.todos',
        route: RouteUri.TODO_SETTINGS,
      }] : []),
      // Timesheet settings are only reachable by users allowed to access timesheets.
      ...(this.currentUserService.hasTimesheetAccess() ? [{
        icon: 'clock' as const,
        label: 'entity.timesheets',
        route: RouteUri.TIMESHEET_SETTINGS,
      }] : []),
      // Accounting settings are only reachable by users allowed to access finances.
      ...(this.currentUserService.hasFinanceAccess() ? [{
        icon: 'chart-line' as const,
        label: 'app.accounting',
        route: RouteUri.ACCOUNTING_SETTINGS,
      }] : []),
      {
        icon: 'send',
        label: 'entity.mail-templates',
        route: RouteUri.MAIL_TEMPLATE_SETTINGS,
      },
    ];

    // Permissions administration is only reachable by users allowed to manage permissions.
    if (this.currentUserService.hasManagePermissions()) {
      items.push({
        icon: 'lock',
        label: 'entity.permissions',
        route: RouteUri.PERMISSIONS_SETTINGS,
      });
    }

    // User administration is only reachable by users allowed to manage users.
    if (this.currentUserService.hasManageUser()) {
      items.push({
        icon: 'users',
        label: 'entity.users',
        route: RouteUri.USER_SETTINGS,
      });
    }

    return items;
  });

}
